import PhotoSwipeLightbox from "photoswipe/dist/photoswipe-lightbox.esm.js";
import PhotoSwipe from 'photoswipe';
import PhotoSwipeVideoPlugin from 'photoswipe-video-plugin';
import { imageSrcSet, originalImage, isVideoMedia } from '@/utils/media';

import CloseHandle from '~/static/images/cross_icon.svg?raw';
import ArrowPrev from '~/static/images/arrow_prev.svg?raw';
import ArrowNext from '~/static/images/arrow_next.svg?raw';

export default {
  data() {
    return {
      photoSwipeOptions: {
        bgOpacity: 1,
        padding: {top: 20, bottom: 20, left: 20, right: 20},
        showHideOpacity: true,
        loop: true,
        showHideAnimationType: 'zoom',
        initialZoomLevel: 'fit',
        imageClickAction: 'next',
        mainClass: 'pswp--custom-icon-colors',
        tapAction: 'next',
        zoom: false,
        close: true,
        counter: true,
        arrowKeys: true,
        wheelToZoom: true,
        closeSVG: CloseHandle,
        arrowPrevSVG: ArrowPrev,
        arrowNextSVG: ArrowNext,
      }
    };
  },
  methods: {
    initPhotoSwipeWithItems(mediaArray, startIndex = 0) {
      const items = mediaArray.map((media) => {
        const attrs = media.attributes;
        const isVideo = isVideoMedia(attrs);
        const size = isVideo ? attrs : originalImage(attrs);

        const width = size?.width || attrs?.width || 1280;
        const height = size?.height || attrs?.height || 720;

        return isVideo
          ? {
            videoSrc: attrs.url,
            width,
            height,
            type: 'video',
            msrc: '',
            autoplay: true,
          }
          : {
            src: size?.url || attrs.url,
            srcset: imageSrcSet(attrs),
            width,
            height,
            type: 'image',
            alt: attrs.alternativeText,
            caption: attrs.caption,
          };
      });

      const lightbox = new PhotoSwipeLightbox({
        ...this.photoSwipeOptions,
        pswpModule: PhotoSwipe,
        dataSource: items,
      });

      new PhotoSwipeVideoPlugin(lightbox, {
        videoAttributes: { controls: '', muted: '', loop: '', playsinline: '', preload: 'auto'},
        autoplay: true,
      });

      lightbox.init();
      lightbox.loadAndOpen(startIndex);
    }
  }
};
